import React from "react";
import { useOutputLang } from "../context/OutputLangContext";

export function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useOutputLang();
  return (
    <div data-testid="lang-toggle" className={`inline-flex items-center rounded-full border border-border bg-card p-0.5 text-sm ${className}`}>
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`rounded-full px-3.5 py-1 transition-colors ${lang === "en" ? "bg-foreground text-background" : "text-muted-foreground"}`}
      >
        English
      </button>
      <button
        data-testid="lang-hi"
        onClick={() => setLang("hi")}
        className={`rounded-full px-3.5 py-1 transition-colors ${lang === "hi" ? "bg-foreground text-background" : "text-muted-foreground"}`}
      >
        हिंदी
      </button>
    </div>
  );
}
